import React, { Component } from "react"
import { Table, Row, Input, message, Select, Icon, Col } from "antd"
import { observable, toJS } from "mobx"
import { observer, inject } from "mobx-react"
import editAbleIcon from "app/styles/images/sp/edit.svg"
import closeIcon from "app/styles/images/sp/close.svg"
import MaterialModal from "app/components/normal/MaterialModal"
import cx from "classnames"
import styled from 'styled-components'
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"
import FlexableFileName from "app/components/normal/FlexableFileName"
import MaterialForm from "app/components/normal/MaterialForm/MaterialForm"
import getPathogen from "app/utils/pathogenDispose"
import { debounce } from "../../../../vendor/util"
import deleteAbleIcon from "app/styles/images/sp/delete.svg"
import TRANINFOS_MAP from "./TraninfosMap"
import { TRANINFOS_OPTION, RANGES_OPTION, CHIPTYPES_OPTION, TRANINFO_DEFAULT_OBJECT } from '../../../../utils/const'
const Option = Select.Option

const OperateBtnWrapper = styled.div`
  display: flex;
  margin-left: 10px;
  .anticon-minus-circle {
    font-size: 14px;
    cursor: pointer;
  }
  .anticon-plus-circle {
    color: #286cac;
    font-size: 14px;
    cursor: pointer;
  }
`

const RequiredStarWrapper = styled.div`
  display: flex;
  align-items: center;
  .required-star {
    color: red;
  }
`

const ObserverRelationSelector = observer(({ record, relations, onChange }) => {
  return (
    <div className="ta-c relation-helper-wrapper">
      {record.marked && (
        <span
          className="relation-helper"
          style={{ background: record.color }}
        />
      )}
      <Select
        style={{ width: "75%" }}
        placeholder="请选择关系"
        value={record.relationName}
        onChange={onChange}
      >
        {relations.slice().map((relation) => (
          <Option key={relation.id}>{relation.name}</Option>
        ))}
      </Select>
    </div>
  )
})

const ObserverPathogenSelector = observer(({ record, onChange }) => {
  const pathogenList = getPathogen(record.relationName)
  let keys = []
  let values = []

  if (pathogenList) {
    keys = [...pathogenList.keys()]
    values = [...pathogenList.values()]
  }

  return (
    <div className="ta-c relation-helper-wrapper">
      <Select
        style={{ width: "90%" }}
        placeholder="请选择致病性"
        value={record.pathogen || undefined}
        onChange={onChange}
      >
        {keys.map((key, index) => (
          <Option key={key}>{values[index]}</Option>
        ))}
      </Select>
    </div>
  )
})

const ChipTypeSelector = observer(({ record, onChange }) => {
  return (
    <div className="ta-c relation-helper-wrapper">
        <Select
          allowClear
          style={{ width: '200px' }}
          placeholder='请选择芯片类型'
          value={record.chipType || undefined}
          onChange={onChange}
        >
          {CHIPTYPES_OPTION.map(chipType => (
            <Option key={chipType.value} value={chipType.value}>{chipType.label}</Option>
          ))}
        </Select>
    </div>
  )
})

const ObserverInput = observer(({ record, field, onChange, placeholder }) => {
  return (
    <div className="ta-c">
      <Input
        style={{ width: "95%" }}
        value={record[field]}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  )
})

const ObserverOperator = observer(({ record, onClick }) => {
  return (
    <Row
      className="table-oprator"
      type="flex"
      justify="space-between"
      align="middle"
    >
      <img
        className={cx({
          disable: !record.hasName && !record.hasRemark,
          "cursor-p": true,
        })}
        title="修改"
        src={editAbleIcon}
        alt=""
        onClick={() => onClick({ record, type: "edit" })}
      />
      <img
        title="删除"
        src={deleteAbleIcon}
        alt=""
        onClick={() => onClick({ record, type: "delete" })}
      />
    </Row>
  )
})

@inject("arrayPgtDataManageDetail")
@observer
export default class extends Component {
  state = {
    showDeleteModal: false,
    showEditModal: false,
    focusedSample: {},
    editedHistory: [],
    syncBtnLoading: false,
  }

  componentDidMount() {
    const { arrayPgtDataManageDetail } = this.props
    arrayPgtDataManageDetail.initTableData().then(
      () => {
        arrayPgtDataManageDetail.loadRelations()
        arrayPgtDataManageDetail.loadGenes()
      },
      (err) => {
        message.error(err.message)
      }
    )
  }

  showOperateModal = ({ record, type }) => {
    if (type === "delete") {
      this.showDeleteModal(record)
    } else {
      this.showEditModal(record)
    }
  }

  showDeleteModal = (record) => {
    this.setState({
      showDeleteModal: true,
      focusedSample: record,
    })
  }

  showEditModal = (record) => {
    this.currentSampleName = record.sampleName

    this.setState({
      showEditModal: true,
      focusedSample: record,
    })
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false,
    })
  }

  onSelectChange = (selectedRowKeys) => {
    this.props.arrayPgtDataManageDetail.selectedRowKeys = selectedRowKeys
  }

  toggleHistory = (visible, record) => {
    const { loadEditHistory, clearEditHistory } = this.props.arrayPgtDataManageDetail
    if (visible) {
      loadEditHistory(record.dataId)
    } else {
      clearEditHistory()
    }
  }

  @debounce()
  parseCSV = () => {
    const { parseCSV } = this.props.arrayPgtDataManageDetail
    parseCSV(this.csvInput.refs.input.value)
      .then(() => {
        message.success("解析成功")
        this.csvInput.refs.input.value = ""
      })
      .catch((err) => {
        message.error(err.message)
        return Promise.reject(err)
      })
  }

  deleteSample = (sampleId) => {
    const {
      arrayPgtDataManageDetail: { deleteSample, deleteData },
    } = this.props
    deleteSample(sampleId).then(
      (res) => {
        deleteData(sampleId)
        this.setState({
          showDeleteModal: false,
        })
        message.success("数据删除成功")
      },
      (err) => {
        message.error(err.message)
      }
    )
  }

  operatorItem = (idx, arr) => {
    const { traninfos, setEdited } = this.props.arrayPgtDataManageDetail
   
    if (idx === arr.length - 1) {
      traninfos.push(TRANINFO_DEFAULT_OBJECT)
    } else {
      traninfos.splice(idx, 1)
    }
    setEdited()
  }

  render() {
    const { focusedSample, showEditModal } = this.state
    const {
      sampleData: {
        dataSamples,
      },
      onInputChange,
      onInputChangeRemark,
      sampleData,
      handleTraninfoObj,
      onTraninfoChange,
      onChipTypeChange,
      onRangeChange,
      onGenesSelect,
      selectedRowKeys,
      totalGenes,
      originGenes,
      setTotalGenes,
      familyInfo,
      onRelationChange,
      relations,
      onPathogenChange,
      onChipTypeAloneChange,
      traninfos
    } = this.props.arrayPgtDataManageDetail
    this.columns = [
      {
        title: <div className="ta-l">文件名称</div>,
        dataIndex: "filename",
        width: 145,
        render: (filename, record, index) => {
          return (
            <FlexableFileName
              wordWrap={true}
              filename={filename}
              matched={record.matched}
            />
          )
        },
      },
       {
        title: <div className="ta-c">外部编号</div>,
        dataIndex: "hospitalSampleName",
        width: 145,
        render: (text) => (
          <div style={{ whiteSpace: "pre-line" }} className="ta-c">
            {text?text:'-'}
          </div>
        ),
      },
      {
        title: <div className="ta-c">姓名</div>,
        dataIndex: "name",
        width: 80,
        render: (name, sample, index) => {
          return (
            <RequiredStarWrapper>
              <span className='required-star'>*</span>
              <ObserverInput
                record={sample}
                field='name'
                placeholder="请填写姓名"
                onChange={(e) => onInputChange(e.target.value, sample, 'name')}
              />
            </RequiredStarWrapper>
          )
        },
      },
       {
        title: <div className="ta-c">样本备注</div>,
        dataInde: "remark",
        width: 70,
        render: (text,sample, record) => {
          return (
             <RequiredStarWrapper>
              {/* <span className='required-star'>*</span> */}
              <ObserverInput
                record={sample}
                field='remark'
                placeholder="请填写样本备注"
                onChange={(e) => onInputChangeRemark(e.target.value, sample, 'remark')}
              />
            </RequiredStarWrapper>
          )
        },
      },
      {
        title: <div className="ta-c">关系</div>,
        width: 160,
        dataIndex: "relationName",
        render: (relationName, sample, index) => (
          <ObserverRelationSelector
            record={sample}
            relations={relations}
            onChange={(relationId) => onRelationChange(relationId, sample)}
          />
        ),
      },
      {
        title: <div className="ta-c">致病性</div>,
        width: 150,
        dataIndex: "pathogen",
        render: (relationName, sample, index) => (
          <ObserverPathogenSelector
            record={sample}
            onChange={(key) => onPathogenChange(key, sample)}
          />
        ),
      },
      {
        title: <div className="ta-c">芯片类型</div>,
        width: 150,
        dataIndex: "chipType",
        render: (relationName, sample, index) => (
          <ChipTypeSelector
            record={sample}
            onChange={(key) => onChipTypeAloneChange(key, sample)}
          />
        ),
      },
      {
        title: <div className="ta-c">上传日期</div>,
        dataIndex: "uploadTime",
        width: 80,
        sorter: (a, b) => new Date(a.uploadTime) - new Date(b.uploadTime),
        render: (text) => (
          <div style={{ whiteSpace: "pre-line" }} className="ta-c">
            {text.replace(" ", "\n")}
          </div>
        ),
      },
      {
        title: <div className="ta-c">Code</div>,
        dataIndex: "fileStatus",
        width: 90,
        render: (text) => (
          <div style={{ whiteSpace: "pre-line" }} className="ta-c">
            {text?text:'-'}
          </div>
        ),
      },
      {
        title: <div className="ta-c">操作</div>,
        dataIndex: "operator",
        width: 60,
        render: (text, record) => (
          <ObserverOperator record={record} onClick={this.showOperateModal} />
        ),
      },
    ]

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    }

    return (
      <div>
        <div className='wrapper-box'>
          <Row type="flex" justify="start" align="middle" className="subtitle">
            <i></i>
            <div>家系信息</div>
          </Row>
          <div>
            <Row type="flex" justify="center">
              <Col span={6}>
                <MaterialFormItem
                  labelWidth={50}
                  required={true}
                  labelText="芯片类型"
                  justify="center"
                >
                  <Select
                    allowClear
                    style={{ width: '200px' }}
                    placeholder='请选择芯片类型'
                    value={toJS(sampleData.chipType)}
                    onChange={(chipType) => onChipTypeChange(chipType)}
                  >
                    {CHIPTYPES_OPTION.map(chipType => (
                      <Option key={chipType.value} value={chipType.value}>{chipType.label}</Option>
                    ))}
                  </Select>
                </MaterialFormItem>
              </Col>
              <Col span={12}>
                <MaterialFormItem
                  labelWidth={25}
                  required={true}
                  labelText="基因"
                  justify="center"
                >
                  <Select
                    multiple
                    allowClear
                    style={{ width: '400px' }}
                    placeholder='请选择基因'
                    value={sampleData.genes && sampleData.genes.slice()}
                    filterOption={(inputValue, option) => option.key.search(new RegExp(inputValue, "i")) > -1}
                    onChange={(genes) => onGenesSelect(genes)}
                    onSearch={(kw) => {
                      if (kw) {
                        const filterGenes = originGenes.filter(gene => gene.includes(kw.toUpperCase()))
                        setTotalGenes(filterGenes)
                      } else {
                        setTotalGenes([])
                      }
                    }}
                  >
                    {totalGenes.slice(0, 50).map((gene) => (
                      <Option key={gene}>{gene}</Option>
                    ))}
                  </Select>
                </MaterialFormItem>
              </Col>
              <Col span={6}>
                <MaterialFormItem
                  labelWidth={25}
                  labelText="范围"
                  justify="center"
                >
                  <Select
                    allowClear
                    style={{ width: '120px' }}
                    placeholder='请选择范围'
                    value={toJS(sampleData.range)}
                    onChange={(range) => onRangeChange(range)}
                  >
                    {RANGES_OPTION.map(range => (
                      <Option key={range.value} value={range.value}>{range.label}</Option>
                    ))}
                  </Select>
                </MaterialFormItem>
              </Col>
            </Row>
            {traninfos.map((traninfo, idx, arr) => {
              return (
                <Row type="flex" justify="center" key={idx}>
                  <Col span={4}>
                    <MaterialFormItem
                      labelWidth={50}
                      required={true}
                      labelText="结构变异"
                      justify="center"
                    >
                      <Select
                        style={{ width: '100px' }}
                        placeholder='请选择结构变异'
                        value={traninfo.type}
                        onChange={(type) => {
                          onTraninfoChange(traninfo, 'type', type, this)
                          handleTraninfoObj(traninfo, type)
                        }}
                      >
                        {TRANINFOS_OPTION.map(traninfo => (
                          <Option
                            key={traninfo.value}
                            value={traninfo.value}
                          >
                            {traninfo.label}
                          </Option>
                        ))}
                      </Select>
                      <OperateBtnWrapper>
                        {idx === arr.length - 1 ?
                          (<Icon
                            type="plus-circle"
                            onClick={() => this.operatorItem(idx, arr)}
                          />
                          ) :
                          (<Icon
                            type="minus-circle"
                            onClick={() => this.operatorItem(idx, arr)}
                          />
                          )}
                      </OperateBtnWrapper>
                    </MaterialFormItem>
                  </Col> 
                  <Col span={20}>
                    {React.cloneElement(TRANINFOS_MAP[traninfo.type], { traninfo, onTraninfoChange })}
                  </Col>
                </Row>
              )
            })}
          </div>
        </div>
        <div className="table-data wrapper-box" style={{ marginTop: '25px !important' }}>
          <Row type="flex" justify="start" align="middle" className="subtitle">
            <i></i>
            <div>数据列表</div>
            <div className="promotion">
              注：在关系中显示同一颜色角色表示数据为同一人
            </div>
          </Row>
          <Table
            className="datamanage-detail-table"
            rowSelection={rowSelection}
            columns={this.columns}
            rowKey={(record) => record.id}
            dataSource={dataSamples}
            pagination={false}
          />
          <MaterialModal
            title="数据删除确认"
            className="upload-delete-modal"
            buttonType="danger"
            buttonText="删除"
            visible={this.state.showDeleteModal}
            action={() => this.deleteSample(focusedSample.id)}
          >
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={() => this.closeModal("showDeleteModal")}
            />
            <div className="sub-title">家系：{familyInfo.name}</div>
            <div className="description">{focusedSample.filename}</div>
            <div className="warning">
              <Icon type="exclamation-circle-o" />
              您确定要删除家系中的本条数据吗？
            </div>
          </MaterialModal>
          <EditModal
            visible={showEditModal}
            sample={focusedSample}
            onClose={() => this.closeModal("showEditModal")}
          // onConfirm={newName => {
          //   focusedSample.sampleName = newName
          //   focusedSample.hasHistory = true
          // }}
          />
        </div>
      </div>
    )
  }
}

@inject("arrayPgtDataManageDetail")
@observer
class EditModal extends Component {
  @observable currentSampleName = ""
  @observable currentremark = ""

  componentWillReceiveProps(props) {
    this.currentSampleName = props.sample.sampleName
    this.currentremark = props.sample.remark
  }

  onSampleNameChange = (e) => {
    this.currentSampleName = e.target.value
  }

  onremarkChange = (e) => {
    this.currentremark = e.target.value
  }

  updateSample = () => {
    const {
      onClose,
      sample,
      arrayPgtDataManageDetail: { updateSample },
    } = this.props
    if (!(this.currentSampleName || " ").trim()) {
      message.warning("样本名不能为空")
      return
    }

    updateSample(
      this.currentSampleName,
      this.currentremark,
      sample.dataId
    ).then(
      (res) => {
        sample.sampleName = this.currentSampleName // 因为 sample 是对 mobx 对象的一个引用
        sample.remark = this.currentremark // 因为 sample 是对 mobx 对象的一个引用
        sample.hasHistory = true // 因为 sample 是对 mobx 对象的一个引用
        sample.hasRemark = true // 因为 sample 是对 mobx 对象的一个引用

        onClose()
        message.success("编辑保存成功")
      },
      (err) => {
        message.error(err.message)
      }
    )
  }

  render() {
    const { sample, visible, onClose } = this.props

    return (
      <MaterialModal
        title="数据编辑"
        buttonText="保存"
        className="pgd-datamanage-detail-modal"
        visible={visible}
        action={this.updateSample}
        buttonType="primary"
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt=" "
          onClick={onClose}
        />
        <MaterialForm justify="center">
          <MaterialFormItem justify="center" labelText="文件名称">
            <FlexableFileName
              className="edit-filename"
              filename={sample.filename}
              matched={true}
            />
          </MaterialFormItem>
          <MaterialFormItem justify="center" labelText="样本名">
            <Input
              className="edit-samplename"
              value={this.currentSampleName}
              onChange={this.onSampleNameChange}
            />
          </MaterialFormItem>
          <MaterialFormItem justify="center" labelText="样本备注">
            <Input
              className="edit-samplename"
              value={this.currentremark}
              onChange={this.onremarkChange}
            />
          </MaterialFormItem>
        </MaterialForm>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/data_manage_detail/containers/DataTable.js